




















































































































































































































































































































































































import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import {
  getContactProperty,
  getContactPropertyDetail,
  getQueryVariable
} from "@/services/api";
import draggable from 'vuedraggable';
import YcColorPicker from "@/components/color-picker/index.js";
import {
  DISABLE_SMS_SUBSCRIPTION_TPLID,
  isEnableFlowTfnSend,
  isEnableFormSubscribeSignup,
  isEnablePrivacySetting,
  isEnableSmsCOICompany,
  isOnlyNewUserTemplate
} from "@/utils/experiment";
import {
  PRIVACY_CHECK_ERROR_TIP_DEFAULT,
  PRIVACY_CHECK_REQUIRED_DEFAULT,
  SUBSCRIBE_SIGNUP_TIP_DEFAULT
} from "@/views/wheelOfFortune/constant/options";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    draggable,
  },
})
export default class componentSetForm extends Vue {

  @Prop(Object)
  setformType!: object;

  @Prop(Array)
  formList!: any;

  @Prop(Array)
  countryList!: any

  @Prop([Number, String])
  templateId!: number | string

  // SKA2792: 固定模板锁定"必选"不可改
  @Prop({ type: Boolean, default: false })
  necessaryLocked!: boolean

  formType: any = {}

  formAddList = ["Email", 'Mobile Number', 'First Name', 'Last Name', "Birthday"]
  defaultCountry = {}
  newFormList = JSON.parse(JSON.stringify(this.formList))
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id
  necessary = true
  placeholder = ''
  List = []
  questionType = ''//单选 多选
  questionTypeList = [
    {
      id: 'Single',
      "value": "单选题"
    },
    {
      id: 'Multiple',
      "value": "多选题"
    },
    { id: 'Date', value: '日期选择' },
    { id: 'Dropdown', value: '下拉菜单' },
  ]
  question = ""
  questionOptionList = []
  optionList = []
  optionListList = []
  formatString = 'yyyy-MM-dd';
  // 是否展示第二条隐私政策外链
  showSecondPrivacyLink: boolean = false;
  initialEnablePrivacyCheck = false;


  get isDisableSmartCollect() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return [193].includes(Number(templateId));
  }

  get isDropdownUnsupportedTemplate() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return ['1', '18'].includes(templateId);
  }

  get filteredQuestionTypeList() {
    if (!this.isDropdownUnsupportedTemplate) return this.questionTypeList;
    return this.questionTypeList.filter((item) => item.id !== 'Dropdown');
  }

  get enablePrivacyShow() {
    return this.formType.enablePrivacyShow !== false;
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting() && sessionStorage.getItem('popType') !== 'WheelOfFortune';
  }

  get enableMultiPrivacyLinks() {
    return sessionStorage.getItem('popType') !== 'WheelOfFortune';
  }

  get showSetCheckbox() {
    return sessionStorage.getItem('popType') === 'POP_WINDOW';
  }

  get enableCollectWay() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    // 新订阅用户发放券包、大转盘模板、嵌入式表单、多步骤采集模板不进行本次功能新增
    return isEnableFlowTfnSend() &&
      !DISABLE_SMS_SUBSCRIPTION_TPLID.includes(templateId) &&
      sessionStorage.getItem('popType') === 'POP_WINDOW';
  }

  get enablePhoneForm() {
    return this.formType.collectWay !== 'smart';
  }

  get isContactRequiredLocked() {
    return this.necessaryLocked && ['Email', 'Mobile Number'].includes(this.formType.type);
  }

  get enableFormSubscribeSignup() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return isEnableFormSubscribeSignup() && ![44].includes(Number(templateId));
  }

  // 仅指定公司可配置“隐私勾选必填设置”
  get showPrivacyRequiredSetting() {
    return isEnableSmsCOICompany();
  }

  get showFormRepeatSignup() {
    return JSON.parse(localStorage.getItem('companyInfo') || '{}').formRepeatSignup;
  }

  get hasSecondPrivacyLink() {
    return !!(this.formType?.link2Text || this.formType?.privacyPolicyLink2);
  }

  get isOnlyNewUserTemplate() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get lockPrivacyCheckRequired() {
    return this.isOnlyNewUserTemplate && this.formType.enablePrivacyCheck;
  }

  filterQuestionOptionList(questionType: string) {
    return this.questionOptionList.filter(item => item.valueType === (questionType === 'Date' ? 3 : 0));
  }

  /**
   * 端隐私勾选必填设置默认值归一化：
   * - 存量模板可能出现 privacyCheckRequired 为 boolean（true/false）
   * - 新模板使用 string（0/1）
   */
  normalizePrivacyCheckDefaults() {
    // privacyCheckRequired
    if (this.formType.privacyCheckRequired === undefined || this.formType.privacyCheckRequired === null) {
      this.$set(this.formType, 'privacyCheckRequired', this.isOnlyNewUserTemplate ? '1' : PRIVACY_CHECK_REQUIRED_DEFAULT);
    } else if (
      this.formType.privacyCheckRequired === true ||
      this.formType.privacyCheckRequired === 1 ||
      this.formType.privacyCheckRequired === '1' ||
      this.formType.privacyCheckRequired === 'required'
    ) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    } else if (
      this.formType.privacyCheckRequired === false ||
      this.formType.privacyCheckRequired === 0 ||
      this.formType.privacyCheckRequired === '0' ||
      this.formType.privacyCheckRequired === 'optional'
    ) {
      this.$set(this.formType, 'privacyCheckRequired', PRIVACY_CHECK_REQUIRED_DEFAULT);
    } else if (!['0', '1'].includes(String(this.formType.privacyCheckRequired))) {
      this.$set(this.formType, 'privacyCheckRequired', this.isOnlyNewUserTemplate ? '1' : PRIVACY_CHECK_REQUIRED_DEFAULT);
    }

    // privacyCheckErrorTip
    if (this.formType.privacyCheckErrorTip === undefined || this.formType.privacyCheckErrorTip === null) {
      this.$set(this.formType, 'privacyCheckErrorTip', PRIVACY_CHECK_ERROR_TIP_DEFAULT);
    }
  }

  normalizeSubscribeSignupDefaults() {
    if (this.formType.formSubscribeSignup === undefined || this.formType.formSubscribeSignup === null) {
      this.$set(this.formType, 'formSubscribeSignup', false);
    }
    if (!this.formType.tipSubscribeEmailText) {
      this.$set(this.formType, 'tipSubscribeEmailText', SUBSCRIBE_SIGNUP_TIP_DEFAULT);
    }
    if (!this.formType.tipSubscribePhoneText) {
      this.$set(this.formType, 'tipSubscribePhoneText', SUBSCRIBE_SIGNUP_TIP_DEFAULT);
    }
  }

  async created(): Promise<void> {
    this.init()
    this.getContactProperty()
  }
  init() {
    this.formType = JSON.parse(JSON.stringify(this.setformType))
    this.normalizeLockedNecessary();
    // console.log(this.formType,'this.formType!!!!')
    if (!this.formType.collectWay) {
      this.$set(this.formType, 'collectWay', 'traditional');
    }
    // 日期格式适配
    if (this.formType.formatString) {
      this.formatString = this.formType.formatString;
    } else {
      this.formType.formatString = this.formatString;
    }
    // 初始化第二条隐私政策外链展示状态（兼容已有数据）
    this.showSecondPrivacyLink = !!(this.formType.link2Text || this.formType.privacyPolicyLink2);
    this.initialEnablePrivacyCheck = !!this.formType.enablePrivacyCheck;
    // console.log('form init', JSON.stringify(this.formType));
    this.defaultCountry['countryAbbreviation'] = this.formType.phoneCountryAbbreviation;
    this.defaultCountry['phoneCode'] = this.formType.phoneCode;
    // 初始化重复提交提示默认值
    if (!this.formType.tipRepeatEmailText) {
      this.$set(this.formType, 'tipRepeatEmailText', 'email already used.');
    }
    if (!this.formType.tipRepeatPhoneText) {
      this.$set(this.formType, 'tipRepeatPhoneText', 'phone already used.');
    }
    this.normalizeSubscribeSignupDefaults();
    // 初始化端隐私勾选必填设置默认值（存量数据兼容）
    this.normalizePrivacyCheckDefaults();
    // 初始化下拉菜单占位文案默认值
    if (this.formType.questionType === 'Dropdown' && !this.formType.placeholder) {
      this.$set(this.formType, 'placeholder', 'Please select');
    }
    if (this.formType.type === '自定义') {
      let optionList = []
      for (let i = 0; i < this.setformType.optionList.length; i++) {
        optionList.push(this.setformType.optionList[i].value);
      }
      if (!optionList[0]) {
        optionList = ['', '']
      }
      this.optionList = optionList

      this.getContactPropertyDetail(this.formType.attributeId);
    }
  }

  normalizeLockedNecessary() {
    if (this.isContactRequiredLocked && this.formType.necessary !== true) {
      this.$set(this.formType, 'necessary', true);
    }
  }
  changeAttribute(item: any) {
    this.newFormList.forEach((i: any) => {
      if (i.attribute === item) {
        this.$message.error('您添加了多个 《' + i.label + '》 属性,请检查设置是否有误')
        this.formType.attribute = ''
        return
      }
    })
    let id = this.questionOptionList.filter((item) => {
      if (item.name == this.formType.attribute) {
        return item
      }
    })
    if (id[0]?.id && !id[0].routine) {
      this.formType.attributeId = id[0]?.id;
      this.formatString = id[0]?.formatString;
      this.formType.formatString = id[0]?.formatString;
      this.getContactPropertyDetail(id[0]?.id)
    } else {
      this.formType.attributeId = null;
      this.optionListList = []
    }
  }

  async getContactProperty() {
    let { data, status } = await getContactProperty({}, false)
    if (status == 200) {
      this.questionOptionList = data.data;
    }
  }

  changeCountryCode(country) {
    this.formType.phoneCode = country.phoneCode;
    this.formType.phoneCountryAbbreviation = country.countryAbbreviation;
  }

  changeFormatString(val) {
    this.formType.formatString = val;
  }

  async getContactPropertyDetail(id: number) {
    if (id) {
      let { data, status } = await getContactPropertyDetail({
        propertyId: id
      }, false)
      if (status == 200) {
        this.optionListList = data.data.valueList;
      }
    } else {
      this.optionListList = []
    }
  }

  getCompanyId() {
    const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    return company?.id;
  }

  save() {
    this.normalizeLockedNecessary();
    if (this.lockPrivacyCheckRequired) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    }
    // console.log('befere save:', JSON.stringify(this.formType));
    // 邮箱校验提示
    if (this.formType.type === 'Email') {
      if (!this.formType.tipInvalidEmailText) {
        this.$message.error("请完善错误信息提示");
        return
      }
      if (!this.formType.tipEmptyEmailText && this.formType.necessary) {
        this.$message.error("请完善必选信息提示");
        return
      }
      if (this.formType.formRepeatSignup && !this.formType.tipRepeatEmailText) {
        this.$message.error("请完善邮箱-重复提交提示");
        return;
      }
      if (this.formType.formSubscribeSignup && !String(this.formType.tipSubscribeEmailText || '').trim()) {
        this.$message.error("请完善已订阅用户提交提示");
        return;
      }
      if (this.formType.enablePrivacyShow) {
        if (!this.formType.text) {
          this.$message.error("请完善政策文本");
          return;
        }
        // 第一条外链（必填）
        if (!this.formType.linkText) {
          this.$message.error("请完善隐私政策链接文案");
          return;
        }
        if (!this.formType.privacyPolicyLink) {
          this.$message.error("请完善隐私链接");
          return;
        }
        // 第二条外链：只要添加了就做校验
        if (this.showSecondPrivacyLink) {
          if (!this.formType.link2Text) {
            this.$message.error("请完善隐私政策链接文案");
            return;
          }
          if (!this.formType.privacyPolicyLink2) {
            this.$message.error("请完善隐私链接");
            return;
          }
          if (!this.formType.joinText || !this.formType.joinText.trim()) {
            this.$message.error("请完善隐私政策链接间连接文字");
            return;
          }
        }
        // 端隐私勾选必填校验（仅当开启了勾选框且配置为必填）
        if (
          this.formType.enablePrivacyCheck &&
          String(this.formType.privacyCheckRequired) === '1' &&
          (!this.formType.privacyCheckErrorTip || !String(this.formType.privacyCheckErrorTip).trim())
        ) {
          this.$message.error("请完善未勾选错误提示");
          return;
        }
      }
    }
    // 手机号校验提示
    if (this.formType.type === 'Mobile Number') {
      if (!this.formType.tipEmptyPhoneText && this.formType.necessary) {
        this.$message.error("请完善必选信息提示");
        return
      }
      if (!this.formType.tipInvalidPhoneText) {
        this.$message.error("请完善错误信息提示");
        return
      }
      if (this.formType.formRepeatSignup && !this.formType.tipRepeatPhoneText) {
        this.$message.error("请完善手机号-重复提交提示");
        return;
      }
      if (this.formType.formSubscribeSignup && !String(this.formType.tipSubscribePhoneText || '').trim()) {
        this.$message.error("请完善已订阅用户提交提示");
        return;
      }
      if (!this.formType.text) {
        this.$message.error("请完善政策文本");
        return
      }
      // 第一条外链（必填）
      if (!this.formType.linkText) {
        this.$message.error("请完善隐私政策链接文案");
        return
      }
      if (!this.formType.privacyPolicyLink) {
        this.$message.error("请完善隐私链接");
        return
      }
      // 第二条外链：只要添加了就做校验
      if (this.showSecondPrivacyLink) {
        if (!this.formType.link2Text) {
          this.$message.error("请完善隐私政策链接文案");
          return;
        }
        if (!this.formType.privacyPolicyLink2) {
          this.$message.error("请完善隐私链接");
          return;
        }
        if (!this.formType.joinText || !this.formType.joinText.trim()) {
          this.$message.error("请完善隐私政策链接间连接文字");
          return;
        }
      }
      // 端隐私勾选必填校验（仅当开启了勾选框且配置为必填）
      if (
        this.formType.enablePrivacyCheck &&
        String(this.formType.privacyCheckRequired) === '1' &&
        (!this.formType.privacyCheckErrorTip || !String(this.formType.privacyCheckErrorTip).trim())
      ) {
        this.$message.error("请完善未勾选错误提示");
        return;
      }
    }
    //校验相关属性
    if (this.formType.type === '自定义') {
      if (!this.formType.attribute) {
        this.$message.error("请选择相关属性");
        this.$nextTick(() => {
          const attributeEl: any = this.$refs.attribute;
          attributeEl.focus();
        })
        return
      }
      if (!this.formType.questionType) {
        this.$message.error("请选择单选或者多选或者日期");
        this.$nextTick(() => {
          const questionTypeEl: any = this.$refs.questionType;
          questionTypeEl.focus();
        })
        return
      }
      let hash = {}

      let id = this.questionOptionList.filter((item) => {
        if (item.name == this.formType.attribute) {
          return item
        }
      })
      if (id[0]) {
        this.formType.attributeId = id[0].id;
        this.formType.routine = id[0].routine;
      } else {
        this.formType.attributeId = null
        this.formType.routine = false
      }

      let newOptionList = []
      if (this.formType.questionType === 'Date') {
        if (!this.formType.question) {
          this.$message.error("有选项未设置，请设置后重新保存");
          return
        }
      } else {
        for (let i = 0; i < this.optionList.length; i++) {
          if (!this.optionList[i]) {
            // console.log(hash)
            this.$message.error("有选项未设置，请设置后重新保存");
            return
          }
          let newObj = this.optionListList.filter((item) => {
            if (item.value == this.optionList[i]) {
              return item
            }
          })
          if (newObj[0]) {
            newOptionList.push(newObj[0])
            if (hash[newObj[0].value]) {
              this.$message.error("不可设置相同的选项，请修改后重新保存");
              return
            }
            hash[newObj[0].value] = true
          } else {
            newOptionList.push({
              value: this.optionList[i]
            })
            if (hash[this.optionList[i]]) {
              this.$message.error("不可设置相同的选项，请修改后重新保存");
              return
            }
            hash[this.optionList[i]] = true
          }
        }
      }

      if (this.formType.questionType === 'Date') {
        if (id[0]) {
          this.formType.label = id[0].label;
        } else {
          this.formType.label = this.formType.attribute;
        }
        this.formType.valueType = 3;
      } else {
        this.formType.label = this.formType.attribute
      }
      this.formType.optionList = newOptionList;
      // 下拉菜单占位文案为空时回退默认值
      if (this.formType.questionType === 'Dropdown' && !this.formType.placeholder) {
        this.formType.placeholder = 'Please select';
      }
    }

    // console.log('after save: ', JSON.stringify(this.formType));
    this.$emit('changFormItem', this.formType)
    this.$emit('close', false)
  }

  close() {
    this.$emit('close', false)
  }

  changeStartWithGtag(key: string, name: string) {
    window?.gtagClick(key, name);
  }

  handleSubscribeSignupTracking(enabled: boolean) {
    if (!enabled) {
      return;
    }
    const formType = this.formType.type;
    if (formType === 'Email') {
      window?.gtagClick('form_edit_selectField_EmailSubDedup', '弹窗_编辑订阅工具_选择采集项_邮箱_提交订阅去重');
    } else if (formType === 'Mobile Number') {
      window?.gtagClick('form_edit_selectField_PNSubDedup', '弹窗_编辑订阅工具_选择采集项_电话号码_提交订阅去重');
    }
  }

  creatOption() {
    const maxOptions = this.formType.questionType === 'Dropdown' ? 20 : 10;
    if (this.optionList.length < maxOptions) {
      this.optionList.push('')
    } else {
      this.$message.error(`选项最多只能有${maxOptions}个`);
    }
  }
  changeOptionList(index: number) {
    if (this.optionList[index].length > 50) {
      this.optionList[index] = this.optionList[index].substring(0, 50)
      this.$message.error("最多为50个字符");
    }
  }
  delOption(index: number) {
    this.optionList.splice(index, 1)
  }
  @Watch('setformType')
  setformTypeWatch(val: any) {
    this.formType = JSON.parse(JSON.stringify(this.setformType))
    this.normalizeLockedNecessary();
    // 初始化重复提交提示默认值
    if (!this.formType.collectWay) {
      this.$set(this.formType, 'collectWay', 'traditional');
    }
    if (!this.formType.tipRepeatEmailText) {
      this.$set(this.formType, 'tipRepeatEmailText', 'email already used.');
    }
    if (!this.formType.tipRepeatPhoneText) {
      this.$set(this.formType, 'tipRepeatPhoneText', 'phone already used.');
    }
    this.normalizeSubscribeSignupDefaults();
    // 同步第二条隐私政策外链展示状态
    this.showSecondPrivacyLink = !!(this.formType.link2Text || this.formType.privacyPolicyLink2);
    this.initialEnablePrivacyCheck = !!this.formType.enablePrivacyCheck;

    // 初始化端隐私勾选必填设置默认值（存量数据兼容）
    this.normalizePrivacyCheckDefaults();
  }
  @Watch('setformType.optionList')
  optionListWatch(val: any) {
    this.optionList = val
  }
  @Watch('formType.attribute')
  attributeWatch(val: any, old: any) {
    if (typeof (val) === 'undefined') {
      return
    }
    if (typeof (old) === 'undefined') {
      return
    }
    this.formType.question = ''
    this.optionList = ['', '']
  }
  @Watch('formType.questionType')
  questionTypeWatch(val: any, old: any) {
    if (typeof (val) === 'undefined') {
      return
    }
    if (typeof (old) === 'undefined') {
      return
    }
    this.formType.attribute = ''
    this.formType.question = ''
    this.optionList = ['', '']
    if (val === 'Dropdown') {
      this.$set(this.formType, 'placeholder', 'Please select');
    }
  }
  @Watch('formType.enablePrivacyCheck')
  enablePrivacyCheckWatch() {
    if (this.lockPrivacyCheckRequired && !this.initialEnablePrivacyCheck) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    }
  }
  // 新增第二条隐私政策外链
  addSecondPrivacyLink() {
    if (this.showSecondPrivacyLink) {
      return;
    }
    this.showSecondPrivacyLink = true;
    // if (!this.formType.link2Text) {
    //   this.$set(this.formType, 'link2Text', 'privacy policy');
    // }
    // if (typeof this.formType.privacyPolicyLink2 === 'undefined') {
    //   this.$set(this.formType, 'privacyPolicyLink2', '');
    // }
    if (!this.formType.joinText) {
      this.$set(this.formType, 'joinText', 'and');
    }
  }
  // 删除第一条外链：如果存在第二条，则将第二条迁移为第一条；否则仅清空第一条
  removeFirstPrivacyLink() {
    if (this.showSecondPrivacyLink) {
      this.formType.linkText = this.formType.link2Text;
      this.formType.privacyPolicyLink = this.formType.privacyPolicyLink2;
      this.formType.link2Text = '';
      this.formType.privacyPolicyLink2 = '';
      this.showSecondPrivacyLink = false;
    } else {
      this.formType.linkText = '';
      this.formType.privacyPolicyLink = '';
    }
  }
  // 删除第二条外链：仅清空第二条并隐藏卡片
  removeSecondPrivacyLink() {
    this.formType.link2Text = '';
    this.formType.privacyPolicyLink2 = '';
    this.showSecondPrivacyLink = false;
  }
}
